<template>
  <VMultiModal :showing="showing && !!folderId">
    <EditorDeckModalsLocalOrServerChoice
      v-if="activeDialog === AddImageSteps.CHOOSE_SOURCE"
      :key="AddImageSteps.CHOOSE_SOURCE"
      showing
      :company-id="deck.company_id"
      :folder-id="folderId"
      :max-resolution="[4096, 4096]"
      file-type="image"
      mime-type="image/jpeg, image/png, image/gif, image/webp"
      @close="close"
      @choose-file="chooseFiles($event), refreshKey++"
      @goto:shelf="activeDialog = AddImageSteps.USE_SHELF"
    />
    <EditorDeckModalsShelfSelector
      v-show="activeDialog === AddImageSteps.USE_SHELF"
      :key="`${refreshKey}-${AddImageSteps.USE_SHELF}`"
      showing
      type="images"
      :folder-id="folderId"
      :current-file="state.file"
      :company-id="deck.company_id"
      file-type="image"
      mime-type="image/jpeg, image/png, image/gif, image/webp"
      @choose-file="chooseFiles($event)"
      @close="close"
      @back="activeDialog = AddImageSteps.CHOOSE_SOURCE"
    />
  </VMultiModal>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { reactive, ref, toRef, watch } from 'vue'

import type { ShelfFile } from '@/entities/shelfFile'
import type { EditDeck } from '@/composables/useEditDeck'

enum AddImageSteps {
  CHOOSE_SOURCE,
  USE_SHELF,
}

const props = defineProps({
  showing: {
    type: Boolean,
    required: true,
  },
  deck: {
    type: Object as PropType<DeepReadonly<EditDeck>>,
    required: true,
  },
  folderId: {
    type: Number,
    default: null,
  },
})

const emit = defineEmits(['update:showing', 'add-slides', 'add-slide'])

const initialState = {
  file: null as ShelfFile | null,
  title: '',
  caption: '',
}
const activeDialog = ref<AddImageSteps>(AddImageSteps.CHOOSE_SOURCE)
const state = reactive({ ...initialState })

// so we can clear the ShelfSelector state when a new image is uploaded
const refreshKey = ref(0)

watch(toRef(props, 'showing'), async showing => {
  if (showing) {
    activeDialog.value = AddImageSteps.CHOOSE_SOURCE
    Object.assign(state, initialState)
  }
})

function chooseFiles(file: ShelfFile) {
  state.file = file
  submit()
}

async function submit() {
  if (!state.file) return

  emit('add-slide', {
    type: 'I',
    deck_id: props.deck.id,
    file_id: state.file?.id,
    title: state.file?.name ?? 'Untitled',
    description: state.caption || null,
  })

  emit('update:showing', false)
}

function close() {
  state.file = null
  emit('update:showing', false)
}
</script>
